<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="邮箱：" prop="email">
                <span>{{model.email}}</span>
            </el-form-item>
            <el-form-item label="CarId：" prop="car_id">
                <span>{{model.car_id}}</span>
            </el-form-item>
            <el-form-item label="VehicleId：" prop="vehicle_id">
                <span>{{model.vehicle_id}}</span>
            </el-form-item>
            <el-form-item label="起始电量：" prop="begin_soc">
                <span>{{model.begin_soc}}%</span>
            </el-form-item>
            <el-form-item label="结束电量：" prop="end_soc">
                <span>{{model.end_soc}}%</span>
            </el-form-item>
            <el-form-item label="增加电量：" prop="add_soc">
                <span>{{model.add_soc}}%</span>
            </el-form-item>
            <el-form-item label="电池健康度：" prop="battery_health">
                <span>{{model.battery_health}}</span>
            </el-form-item>
            <el-form-item label="时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'batteryHealthInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                email: '',
                car_id: '',
                vehicle_id: '',
                begin_soc: '',
                end_soc: '',
                add_soc: '',
                battery_health: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/batteryhealth/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>